import *as _ from 'lodash'
import {TransactionBO} from "./TransactionBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_CustomerExternalRelationshipRow,
    WB_TransactionItemRow,
    WB_TransactionRow,
    WB_TransactionTypeRow
} from "../PA.Core/PAdbSchemaRows";

export class TransactionBOValidations {

    static ValidateEmptyFields(aBO: TransactionBO): Promise<void> {

        return new Promise<void>((resolve, error) =>{
            // Validate Transaction
            if (_.isEmpty(aBO.WB_Transaction.cif.TXN_ID) || _.isNull(aBO.WB_Transaction.cif.TXN_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'transactionid',
                        title: "Transaction ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('transactionid')
            }

            if (_.isEmpty(aBO.WB_Transaction.cif.TXN_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'transactionname',
                        title: "Transaction Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('transactionname')
            }

            if (_.isEmpty(aBO.WB_Transaction.cif.SOURCE_ID) || _.isNull(aBO.WB_Transaction.cif.SOURCE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'sourceid',
                        title: "Source ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sourceid')
            }

            if (_.isEmpty(aBO.WB_Transaction.cif.TXN_DATE)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'txndate',
                        title: "Transaction Date cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('txndate')
            }

            let bAmountInvalid = false
            let customerIdInvalid = false;
            let productIdInvalid =false;
            let fundtypevalid = false
            let txninvalid = false
            debugger
            _.forEach(_.filter(aBO.WB_Transaction.WB_TransactionItemRows, (x: WB_TransactionItemRow) => x.isActive) , (aRow)=> {

                if (aRow.cif.TXN_AMOUNT < 0) {
                    bAmountInvalid = true
                }

                if (_.isUndefined(aRow.cif.WB_CUST_ID) || _.isNull(aRow.cif.WB_FUNDTYPE_ID)) {
                    customerIdInvalid = true

                }
                if (_.isUndefined(aRow.cif.WB_PRDGRP_ID) || _.isNull(aRow.cif.WB_FUNDTYPE_ID)) {
                    productIdInvalid = true

                }
                if (_.isUndefined(aRow.cif.WB_FUNDTYPE_ID) || _.isNull(aRow.cif.WB_FUNDTYPE_ID)) {
                    fundtypevalid = true

                }

                if (_.isUndefined(aRow.cif.TXN_AMOUNT) || _.isNull(aRow.cif.TXN_AMOUNT)) {
                    txninvalid = true

                }



            })
            if (customerIdInvalid) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'custinvalid',
                        type: MessageType.Error,
                        title: "Customer ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('custinvalid')
            }

            if (productIdInvalid) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'productinvalid',
                        type: MessageType.Error,
                        title: "Product ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('productinvalid')
            }

            if (fundtypevalid) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'fundtype',
                        type: MessageType.Error,
                        title: "Fund Type cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('fundtype')
            }

            if (txninvalid) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'txninvalid',
                        type: MessageType.Error,
                        title: "Transaction Amount cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('txninvalid')
            }


            if (bAmountInvalid) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'AmountInvalid',
                        type: MessageType.Error,
                        title: "Transaction amount cannot be negative",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('AmountInvalid')
            }


            resolve()
        })
    }

}